export default {
  数据权限管理: 'Data Permission Management',
  '说明：': 'Description:',
  '私有：登录人数据权限不同，看到的数据范围不同，上级部门的部门负责人可以 看到下级部门的所有数据。数据可以设置协作人，且可以对协作人指定是读写、只读权限': 'Private: The data scope seen by users varies according to their data permissions. Department heads of higher levels can see all data of lower-level departments. Data can be shared with collaborators, and specific permissions (read/write or read-only) can be assigned to them.',
  '全员公开：数据再全员共享，与登录人的数据权限无关，租户内每个人都能看到这个对象下的所有数据': 'Public: Data is shared with all users, regardless of their individual data permissions. Every user within the tenant can see all data under this object.',
  '对象名称：': 'Object Name:',
  '权限设置：': 'Permission Settings:',
  保存: 'Save',
  私有: 'Private',
  全员公开: 'Public'
};
